import { render } from "./ListDashboard.vue?vue&type=template&id=067d97a7"
import script from "./ListDashboard.vue?vue&type=script&lang=js"
export * from "./ListDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__